export default "__VITE_ASSET__BaLc_vlz__"